import { render, staticRenderFns } from "./SetOriginal.vue?vue&type=template&id=527f136c&scoped=true&"
import script from "./SetOriginal.vue?vue&type=script&lang=js&"
export * from "./SetOriginal.vue?vue&type=script&lang=js&"
import style0 from "./SetOriginal.vue?vue&type=style&index=0&id=527f136c&lang=less&scoped=true&"
import style1 from "./SetOriginal.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f136c",
  null
  
)

export default component.exports